import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const modalImageDefaultVariants = {}
const modalImageCompoundVariants = []

const modalImageSlotNames = [
  [
    "content",
    "modal-image__content"
  ],
  [
    "icon",
    "modal-image__icon"
  ]
]
const modalImageSlotFns = /* @__PURE__ */ modalImageSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, modalImageDefaultVariants, getSlotCompoundVariant(modalImageCompoundVariants, slotName))])

const modalImageFn = memo((props = {}) => {
  return Object.fromEntries(modalImageSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const modalImageVariantKeys = []
const getVariantProps = (variants) => ({ ...modalImageDefaultVariants, ...compact(variants) })

export const modalImage = /* @__PURE__ */ Object.assign(modalImageFn, {
  __recipe__: false,
  __name__: 'modalImage',
  raw: (props) => props,
  variantKeys: modalImageVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, modalImageVariantKeys)
  },
  getVariantProps
})